import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../contexts/Theme/ThemeContext";
import { ClubeApi } from "../../hooks/clubeApi";
import AulaCard from "./AulaCard/AulaCard";
import { ContainerVitrine } from "./styles";
import { ClubeTrilha } from "../../types/Clube";
import bannerClube from "../../assets/newImages/clube/banner-clube-conecta.jpg";

// Vitrine do Clube Conectado: banner de boas-vindas + uma seção por trilha,
// cada uma com uma linha horizontal de aulas e o link "ver trilha completa".
const Vitrine: React.FC = () => {
  const { theme } = useTheme();
  const navigate = useNavigate();
  const clubeApi = ClubeApi();
  const [trilhas, setTrilhas] = useState<ClubeTrilha[]>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    clubeApi.registrarEvento("acesso_vitrine");
    clubeApi
      .getVitrine()
      .then((res) => setTrilhas(res?.trilhas || []))
      .finally(() => setLoaded(true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!loaded) return <div style={{ padding: "4rem 10rem" }}>Carregando...</div>;

  return (
    <ContainerVitrine theme={theme}>
      <div className="banner-clube">
        <img className="capa" src={bannerClube} alt="Clube Conectado" />
      </div>

      {trilhas.map((trilha) => (
        <div className="trilha-secao" key={trilha.id}>
          <div className="secao-header">
            <div>
              <strong className="fonteTitulo">{trilha.titulo}</strong>
            </div>
            <div
              className="ver-trilha fonteTexto"
              onClick={() =>
                navigate(
                  `/clube-conectado/trilha/${trilha.id}/${encodeURIComponent(
                    trilha.titulo
                  )}`
                )
              }
            >
              + ver trilha completa
            </div>
          </div>
          <div className="linha-aulas scrollBonitoBottom">
            {(trilha.aulas || []).map((aula) => (
              <AulaCard
                key={aula.id}
                aula={aula}
                onClick={() =>
                  navigate(
                    `/clube-conectado/trilha/${trilha.id}/${encodeURIComponent(
                      trilha.titulo
                    )}/aula/${aula.id}/${encodeURIComponent(aula.titulo)}`
                  )
                }
              />
            ))}
          </div>
        </div>
      ))}
    </ContainerVitrine>
  );
};

export default Vitrine;
